import Emitter from "es6-event-emitter";
import throttle from "lodash.throttle";
import {
  CLICKED_PAGE_ARTICLE_READER,
  CLICKED_PAGE_ENRICHMENTBUTTON_READER,
  CLICKED_PAGE_NEXT_BOT_READER,
  CLICKED_PAGE_NEXT_READER,
  CLICKED_PAGE_NEXT_TOP_READER,
  CLICKED_PAGE_PREV_BOT_READER,
  CLICKED_PAGE_PREV_READER,
  CLICKED_PAGE_PREV_TOP_READER,
  PAN_PAGE,
  PERCENTAGE_IN_VIEW_COMPUTED,
  ZOOM_PAGE_IN_READER_ON_DESKTOP,
  ZOOM_PAGE_OUT_READER_ON_DESKTOP,
} from "./../../../common/analytics/analyticsevents";
import ArticleLightBoxController from "./../../../common/components/articleLightbox/albController";
import ClickZonesComponent from "./../../../common/components/clickZonesComponent";
import readerMixin from "./../../../common/components/readerMixin";
import APIManager from "./../../../common/utilities/apimanager";
import {
  countPercentOfContainerInZoom,
  getPercentInViewForSinglePage,
} from "./../../../common/utilities/percentageInViewUtils";
import template from "./../templates/readerComponent.dust";
// eslint-disable-next-line
import { turn } from "./../vendors/turn"; // this is needed!
import FullScreenComponent from "./fullscreenComponent";
import GrabToPan from "./grabToPanComponent";
import PdfPage from "./pdfPageComponent";
import ZoomComponent from "./zoomComponent";

export default class ReplicaReaderComponent extends Emitter {
  static componentName = "ReplicaReaderComponent";

  _requestDownloadCounter = 0;
  _requestDownloadLimit = 10;

  constructor(pubStore, appState, options) {
    super();
    this._pubStore = pubStore;
    this._appState = appState;
    this._options = options;
    this.DOMContainer = document.getElementById("reader");
    this.pageContainerSelector = ".page";
    this.zoomScale = 1;
    this.desktopMaxZoom = appState.isDoublePage
      ? this._options.zoom.desktopMaxZoom.doublePageMode
      : this._options.zoom.desktopMaxZoom.singlePageMode;
    this.inFullScreenMode = false;
    this.resizeBookNumber = 0;
    this.clicksOnReadingArea = 0;
    this.readerClickTimeout = null;
    this._appState.setPagesPercentageInView(!this._appState.isDoublePage);
    this._onKeydownHandler = throttle(this._onKeydownHandler, 500);
    this._onWidowResize = throttle(this._onWidowResize, 100);
    if (this._appState.analyticsManager.cmpManager) {
      this._appState.analyticsManager.cmpManager.on(
        "userConsent:changed",
        () => {
          if (this._appState.isReader) {
            readerMixin.triggerPageViewEvent.call(this);
          }
        }
      );
    }
  }

  render = () => {
    window.addEventListener("resize", this._onWidowResize);
    this.totalPages = this._appState.totalPages;

    this._initPdfPages();

    return this._renderComponent().then(() => {
      this._recalculatePercentageInView();
      readerMixin.triggerPageViewEvent.call(this);
    });
  };

  zoomCenterPoint(zoomScale, centerPoint = null) {
    this._zoom(zoomScale);
    const center = centerPoint || this._getCenter();
    this.zoomScale = zoomScale;
    this._resizeBook();
    this._setReaderDimensions(true);
    this._setCenter(center);
    this._recalculatePercentageInView();
  }

  destroy() {
    window.removeEventListener("resize", this._onWidowResize);
    this._appState.off("appState:currentpagechanged", this._goToPage);
    this._appState.off(
      "appState:articleLightboxClosed",
      this._enablePageInteraction
    );
    this._appState.off(
      "appState:articleLightboxOpened",
      this._disablePageInteraction
    );

    $("#turn-reader").turn("destroy");
    this._resetContainerDimentions();
    this.previousLink.removeEventListener("click", this._goToPreviousPage);
    this.nextLink.removeEventListener("click", this._goToNextPage);
    this.singlePagePreviousLink.removeEventListener(
      "click",
      this._goToPreviousPage
    );
    this.singlePageNextLink.removeEventListener("click", this._goToNextPage);
    $(this.DOMContainer).off(
      "click",
      `${this.pageContainerSelector} .swiper-slide-page-click`,
      this._onZoneClickHandler
    );
    $(this.DOMContainer).off(
      "click",
      `${this.pageContainerSelector} .swiper-slide-page-click .extra-button-container`,
      this._onZoneButtonClickHandler
    );
    $("#turn-reader").off("dblclick", this._zoomPageInPoint);
    $(this.DOMContainer).off("mousewheel", this._zoomOnScroll);
    $(this.DOMContainer).off("wheel", this._zoomOnScroll);
    if (this.readerClickTimeout) clearTimeout(this.readerClickTimeout);
    this.fullScreenComponent.off(
      "fullScreenComponent:startFullScreen",
      this._onFullScreenStart
    );
    this.fullScreenComponent.off(
      "fullScreenComponent:stopFullScreen",
      this._onFullScreenStop
    );
    this.fullScreenComponent.destroy();
    this.grabToPan.off("grabToPan:panEnd", this._onPanEnd);
    this.grabToPan.off("grabToPan:panStart", this._onPanStart);
    this.grabToPan.disableGrabToPan();
    this.zoomComponent.destroy();
    document.removeEventListener("keydown", this._onKeydownHandler);
  }

  //////////////

  _resetContainerDimentions() {
    const readerEl = document.querySelector("#reader");
    readerEl.style.width = "initial";
    readerEl.style.height = "initial";
  }

  _zoomMousePoint(zoomScale, mouse) {
    if (zoomScale === 1) {
      this._resetZooming();
      return;
    }
    this._zoom(zoomScale);
    const center = this._getPoint(mouse);
    this.zoomScale = zoomScale;
    this._resizeBook(this._recalculatePercentageInView.bind(this));
    this._setPoint(center, mouse);
  }

  checkAlb() {
    if (this.alb) {
      this.alb.goTo(this._appState.currentPage, this._appState.contentid);
    }
  }

  _zoom(zoomScale) {
    if (
      zoomScale === this.zoomScale ||
      zoomScale < 1 ||
      zoomScale > this.desktopMaxZoom
    ) {
      return;
    }
    this._appState.zoomScale = zoomScale;
    if (this.zoomScale === 1 && zoomScale > 1) {
      this._disableTurning();
    } else if (this.zoomScale !== 1 && zoomScale === 1) {
      this._enableTurning();
    }
  }

  _initPdfPages() {
    this.pdfPages = [];
    for (let i = 0; i < this.totalPages; i++) {
      this.pdfPages.push(null);
    }
  }

  _disableTurning() {
    $("#turn-reader").turn("disable", true);
  }

  _enableTurning() {
    $("#turn-reader").turn("disable", false);
  }

  _resetZooming() {
    this.zoomCenterPoint(1);
    this.zoomComponent.reset();
  }

  _renderComponent() {
    return Promise.resolve().then(() => {
      Dust.render(template, {}, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.DOMContent = this.DOMContainer.querySelector(".reader-container");
        this.$readerComponentEl = $(".reader-component");
        this.previousLink = document.getElementById("reader-previous");
        this.nextLink = document.getElementById("reader-next");
        this.singlePageNextLink = document.getElementById(
          "reader-next-singlePage"
        );
        this.singlePagePreviousLink = document.getElementById(
          "reader-previous-singlePage"
        );
        this._initGrabToPan();
        this._renderBook();
        this._attachEventListeners();
      });
    });
  }

  _setReaderDimensions(afterZoom = false) {
    this._dimensions = this._countRelativeDimentions();
    const reader = this.DOMContainer.querySelector(".reader-wrapper");
    const readerEl = document.querySelector("#reader");
    if (reader) {
      if (this._appState.isDoublePage) {
        reader.setAttribute(
          "style",
          `height:${this._dimensions.height}px; width:${
            this._dimensions.width * 2
          }px`
        );
        readerEl.setAttribute(
          "style",
          `height:${this._dimensions.height}px; width:${
            this._dimensions.width * 2
          }px`
        );
      } else {
        if (afterZoom) {
          if (this.zoomScale == 1) {
            reader.setAttribute(
              "style",
              `height:${this._dimensions.height * this.zoomScale}px; width:${
                this._dimensions.width
              }px`
            );
          } else {
            const width = document.querySelector("#turn-reader").offsetWidth;
            readerEl.setAttribute("style", `width:${this._dimensions.width}px`);
            reader.setAttribute(
              "style",
              `height:${
                this._dimensions.height * this.zoomScale
              }px; width:${width}px`
            );
          }
        } else {
          reader.setAttribute(
            "style",
            `height:${this._dimensions.height}px; width:${this._dimensions.width}px`
          );
          readerEl.setAttribute("style", `width:${this._dimensions.width}px`);
        }
      }
    }
  }

  _initGrabToPan() {
    const singlePageEl = this._appState.isDoublePage
      ? this.DOMContent
      : document.querySelector("#reader");
    this.grabToPan = new GrabToPan(singlePageEl);
    this.grabToPan.on("grabToPan:panStart", this._onPanStart);
    this.grabToPan.on("grabToPan:panEnd", this._onPanEnd);
  }

  _pdfPan(panning) {
    if (this._appState.usePdf) {
      const view = $("#turn-reader").turn("view");
      view.forEach((pageNr) => {
        if (this.pdfPages[pageNr - 1]) {
          this.pdfPages[pageNr - 1].pdfPan(panning);
        }
      });
    }
  }

  _onPanStart = () => {
    this._pdfPan(false);
  };

  _onPanEnd = () => {
    this._pdfPan(false);
    this._recalculatePercentageInView();

    // correct scrollLeft of container of first/last page when needed
    const [leftPageNr, rightPageNr] = $("#turn-reader").turn("view");
    const grabToPanContainer = this.grabToPan.DOMContainer;

    if (
      leftPageNr === 0 &&
      grabToPanContainer.scrollLeft < grabToPanContainer.scrollWidth / 2
    ) {
      grabToPanContainer.scrollLeft = grabToPanContainer.scrollWidth / 2;
    } else if (
      rightPageNr === 0 &&
      grabToPanContainer.scrollWidth / 2 - grabToPanContainer.scrollLeft <
        grabToPanContainer.offsetWidth
    ) {
      grabToPanContainer.scrollLeft =
        grabToPanContainer.scrollWidth / 2 - grabToPanContainer.offsetWidth;
    }
    if (this.zoomScale > 1) this._appState.triggerEvent(PAN_PAGE);
  };

  _attachEventListeners() {
    this._appState.on("appState:currentpagechanged", this._goToPage);
    this._appState.on(
      "appState:articleLightboxClosed",
      this._enablePageInteraction
    );
    this._appState.on(
      "appState:articleLightboxOpened",
      this._disablePageInteraction
    );
    this.previousLink.addEventListener("click", this._goToPreviousPage);
    this.singlePagePreviousLink.addEventListener(
      "click",
      this._goToPreviousPage
    );
    this.nextLink.addEventListener("click", this._goToNextPage);
    this.singlePageNextLink.addEventListener("click", this._goToNextPage);
    document.addEventListener("keydown", this._onKeydownHandler);

    const scrollingContainer = document.querySelector("#reader");

    scrollingContainer.addEventListener("scroll", this.onPageScroll);
  }

  _onReadingModeChanged = () => {
    this.destroy();
    this._onWidowResize();
    this._initGrabToPan();
    this._renderBook();
    this._attachEventListeners();
  };

  _goToPage = (currentPageIndex, originIsReader) => {
    if (
      currentPageIndex + 1 !== $("#turn-reader").turn("page") ||
      originIsReader
    ) {
      this._resetZooming();

      const turnDisabled = $("#turn-reader").turn("disabled");

      if (turnDisabled) $("#turn-reader").turn("disabled", false);
      $("#turn-reader").turn("page", currentPageIndex + 1);
      if (turnDisabled) $("#turn-reader").turn("disabled", true);

      // We want to trigger VIEW_PAGE event only if pages changed,
      // not if router changed (for example because light box was opened)
      const [leftPageNr, rightPageNr] = $("#turn-reader").turn("view");

      if (
        this.currentRenderedPages[0] !== leftPageNr ||
        this.currentRenderedPages[1] !== rightPageNr
      ) {
        this.currentRenderedPages = [leftPageNr, rightPageNr];
        const leftPage = this._pubStore.CPackagePages[leftPageNr - 1];
        const rightPage = this._pubStore.CPackagePages[rightPageNr - 1];

        this._appState.setActivePages([leftPage, rightPage]);
        readerMixin.triggerPageViewEvent.call(this);
      }
    }
  };

  _onKeydownHandler = (e) => {
    const key = e.which || e.keyCode;
    switch (
      key // eslint-disable-line
    ) {
      case 37: // 37 = left
        if (!this._appState.articleLightBoxDisplayed) {
          this._goToPreviousPage();
        }
        break;
      case 39: // 39 = right
        if (!this._appState.articleLightBoxDisplayed) {
          this._goToNextPage();
        }
        break;
    }
  };

  _goToNextPage = () => {
    this._resetZooming();
    this._scrollTop();
    $("#turn-reader").turn("next");
    this._appState.triggerEvent(CLICKED_PAGE_NEXT_READER);
  };

  _goToPreviousPage = () => {
    this._scrollTop();
    this._resetZooming();
    $("#turn-reader").turn("previous");
    this._appState.triggerEvent(CLICKED_PAGE_PREV_READER);
  };

  _scrollTop() {
    if (this._appState.isDoublePage == false) {
      const scrollingContainer = document.querySelector("#reader");
      scrollingContainer.scrollTop = 0;
    }
  }

  _turnedPageHandler = (event, page, view) => {
    this._appState.changeCurrentPage(page - 1);
    this._setActivePagesInState(view);
    this._toggleNavigationButtons(page);
    this._startPdf(view);
  };

  _stopPdf(view) {
    view.forEach((pageNr) => {
      if (this.pdfPages[pageNr - 1]) {
        this.pdfPages[pageNr - 1].hidePdf();
      }
    });
  }

  _startPdf(view) {
    if (this._appState.usePdf) {
      view.forEach((pageNr) => {
        if (!this.pdfPages[pageNr - 1]) {
          const currentPage = this._pubStore.findPageByPageNumber(pageNr);
          const pageContainer = this.DOMContainer.querySelector(
            `.page-wrapper .page.p${pageNr}`
          );
          if (currentPage && pageContainer) {
            this.pdfPages[pageNr - 1] = new PdfPage(
              this._appState,
              APIManager,
              pageContainer,
              currentPage.PublicationPageID,
              pageNr,
              this._options.pdfPage
            );
          }
        }
        if (this.pdfPages[pageNr - 1]) {
          this.pdfPages[pageNr - 1].renderPdf();
        }
      });
    }
  }

  _prefetchPDF(view) {
    if (this._appState.usePdf) {
      view.forEach((pageNr) => {
        if (this.pdfPages[pageNr - 1]) {
          this.pdfPages[pageNr - 1].prefetchPDF();
        }
      });
    }
  }

  _renderBook() {
    let currentPageNr = this._appState.currentPage + 1;
    if (currentPageNr > this.totalPages) currentPageNr = 1;

    let released = null;

    this._setReaderDimensions();

    this._toggleNavigationButtons(this._appState.currentPage + 1);

    $("#turn-reader").turn({
      display: this._appState.isDoublePage ? "double" : "single",
      height: this._dimensions.height,
      width: this._appState.isDoublePage
        ? this._dimensions.width * 2
        : this._dimensions.width,
      gradients: true,
      page: currentPageNr,
      pages: this._pubStore.CPackagePages.length,
      duration: 450,
      when: {
        missing: (event, pages) => {
          for (let i = 0, len = pages.length; i < len; i++) {
            this._addPage(pages[i]);
          }
        },
        released: (event, coords) => {
          released = coords.corner.substring(0, 1);
        },
        start: () => {
          this.grabToPan.disableGrabToPan();
        },
        turned: (event, page, view) => {
          this._appState.changeCurrentPage(page - 1, false, false, true);
          this._setActivePagesInState(view);
          this._toggleNavigationButtons(page);
          this._startPdf(view);
        },
        first: () => {
          this.previousLink.classList.add("hidden");
          this.singlePagePreviousLink.classList.add("hidden");
        },
        last: () => {
          this.nextLink.classList.add("hidden");
          this.singlePageNextLink.classList.add("hidden");
        },
        turning: (event, page, view) => {
          if (!released) return;

          const futurePage = view[0] || view;
          const eventName = `${released}${page <= futurePage ? "r" : "l"}`;

          switch (
            eventName // eslint-disable-line
          ) {
            case "tl":
              this._scrollTop();

              this._appState.triggerEvent(CLICKED_PAGE_PREV_TOP_READER);
              break;
            case "tr":
              this._scrollTop();

              this._appState.triggerEvent(CLICKED_PAGE_NEXT_TOP_READER);
              break;
            case "bl":
              this._scrollTop();

              this._appState.triggerEvent(CLICKED_PAGE_PREV_BOT_READER);
              break;
            case "br":
              this._scrollTop();
              this._appState.triggerEvent(CLICKED_PAGE_NEXT_BOT_READER);
              break;
          }
        },
        end: () => {
          this.grabToPan.enableGrabToPan();
          released = null;
        },
      },
    });

    this.currentRenderedPages = $("#turn-reader").turn("view");

    this.zoomComponent = new ZoomComponent(
      this,
      this._options.zoom,
      this._appState
    );
    this.zoomComponent.render();

    this.fullScreenComponent = new FullScreenComponent(
      this._options.fullScreen,
      this._appState
    );
    this.fullScreenComponent.on(
      "fullScreenComponent:startFullScreen",
      this._onFullScreenStart
    );
    this.fullScreenComponent.on(
      "fullScreenComponent:stopFullScreen",
      this._onFullScreenStop
    );

    this._initAlb();
    this._startPdf($("#turn-reader").turn("view"));
    this.trigger("reader:rendered", "replica");
  }

  _onFullScreenStart = () => {
    this.inFullScreenMode = true;
    this._onWidowResize();
  };
  _onFullScreenStop = () => {
    this.inFullScreenMode = false;
    this._onWidowResize();
  };

  _disablePageInteraction = () => {
    this.grabToPan.disableGrabToPan();
    $("#turn-reader").turn("disable", true);
  };

  _enablePageInteraction = () => {
    this.grabToPan.enableGrabToPan();
    $("#turn-reader").turn("disable", false);
  };

  _initAlb() {
    this.alb = new ArticleLightBoxController(
      this._appState,
      this._pubStore.createSlides(false),
      this._options.albcontroller
    );
    $(this.DOMContainer).on(
      "click",
      `${this.pageContainerSelector} .swiper-slide-page-click`,
      this._onZoneClickHandler
    );
    $(this.DOMContainer).on(
      "click",
      `${this.pageContainerSelector} .extra-button-container`,
      this._onZoneButtonClickHandler
    );
    $("#turn-reader").on("dblclick", this._zoomPageInPoint);
    if (this._appState.isDoublePage) {
      $(this.DOMContainer).on("wheel", this._zoomOnScroll);
    } else {
      $(this.DOMContainer).off("wheel", this._zoomOnScroll);
    }
    this.alb.on("albController:closeAlb", () => {
      this.trigger("albController:closeAlb");
    });
    this.alb.render();
  }

  _onZoneClickHandler = (e) => {
    e.stopPropagation();
    const currentTarget = e.currentTarget;
    this._appState.trigger("replicaReader:clicked");
    this.clicksOnReadingArea++;
    if (this.clicksOnReadingArea === 1) {
      this.readerClickTimeout = setTimeout(() => {
        if (this.clicksOnReadingArea === 1) {
          this._appState.triggerEvent(CLICKED_PAGE_ARTICLE_READER);
          if (currentTarget.dataset.extraurl) {
            const urlWithConsentParams =
              this._appState.analyticsManager.checkEnrichmentUrl(
                currentTarget.dataset.extraurl
              );
            this._appState.triggerEvent(CLICKED_PAGE_ENRICHMENTBUTTON_READER, {
              externalUrl:
                urlWithConsentParams || currentTarget.dataset.extraurl,
            });
            if (urlWithConsentParams) {
              window.open(urlWithConsentParams, "_blank");
            } else {
              window.open(currentTarget.dataset.extraurl, "_blank");
            }
          } else {
            const contentID = currentTarget.dataset.contentid;
            const slideIndex = currentTarget.dataset.index;
            this.alb.open({ contentID, slideIndex });
            this._disablePageInteraction();
          }
        }
        this.clicksOnReadingArea = 0;
      }, 200);
    }
  };

  _zoomOnScroll = throttle(({ originalEvent }) => {
    if (this._appState.isDoublePage) {
      const zoomStep = this.zoomComponent.zoomStep;

      if (this._mouseIsHoveringWhiteSpace(originalEvent)) return;

      if (originalEvent.deltaY < 0 && this.zoomScale < this.desktopMaxZoom) {
        const scale =
          this.zoomScale + zoomStep > this.desktopMaxZoom
            ? this.desktopMaxZoom
            : this.zoomScale + zoomStep;
        this._zoomMousePoint(
          scale,
          {
            x: originalEvent.pageX,
            y: originalEvent.pageY,
          },
          true
        );
        this.zoomComponent.setProgress(this.zoomScale);
        this._appState.triggerEvent(ZOOM_PAGE_IN_READER_ON_DESKTOP);
      } else if (originalEvent.deltaY > 0 && this.zoomScale > 1) {
        const scale =
          this.zoomScale - zoomStep < 1 ? 1 : this.zoomScale - zoomStep;
        this._zoomMousePoint(
          scale,
          {
            x: originalEvent.pageX,
            y: originalEvent.pageY,
          },
          true
        );
        this.zoomComponent.setProgress(this.zoomScale);
        this._appState.triggerEvent(ZOOM_PAGE_OUT_READER_ON_DESKTOP);
      }
    }
  }, 200);

  _zoomPageInPoint = (e) => {
    e.stopPropagation();
    if (this._mouseIsHoveringWhiteSpace(e)) return;
    if (this.zoomScale === this.desktopMaxZoom) {
      this.zoomComponent.reset();
      this.zoomCenterPoint(1);
      this._appState.triggerEvent(ZOOM_PAGE_OUT_READER_ON_DESKTOP);
    } else {
      let zoomStep = this.zoomScale + Math.floor(this.desktopMaxZoom / 2);
      zoomStep =
        zoomStep < this.desktopMaxZoom ? zoomStep : this.desktopMaxZoom;
      this.zoomCenterPoint(zoomStep, {
        x: e.pageX - $(this.DOMContainer).offset().left,
        y: e.pageY - $(this.DOMContainer).offset().top,
      });
      this.zoomComponent.setProgress(zoomStep);
      this._appState.triggerEvent(ZOOM_PAGE_IN_READER_ON_DESKTOP);
    }
  };

  _onZoneButtonClickHandler = (e) => {
    e.stopPropagation();
    const currentTarget = e.currentTarget;
    if (currentTarget.dataset.extraurl) {
      const urlWithConsentParams =
        this._appState.analyticsManager.checkEnrichmentUrl(
          currentTarget.dataset.extraurl
        );
      if (urlWithConsentParams) {
        this._appState.triggerEvent(
          CLICKED_PAGE_ENRICHMENTBUTTON_READER,
          {
            externalUrl: urlWithConsentParams,
          },
          true
        );
        window.open(urlWithConsentParams, "_blank");
      } else {
        this._appState.triggerEvent(
          CLICKED_PAGE_ENRICHMENTBUTTON_READER,
          {
            externalUrl: currentTarget.dataset.extraurl,
          },
          true
        );
        window.open(currentTarget.dataset.extraurl, "_blank");
      }
    } else {
      const contentID = currentTarget.dataset.contentid;
      const slideIndex = currentTarget.dataset.index;
      const scrollToExtra = true;
      this._appState.triggerEvent(CLICKED_PAGE_ENRICHMENTBUTTON_READER);
      this.alb.open({ contentID, scrollToExtra, slideIndex });
    }
  };

  _addPage(pageNr) {
    const pageElement = $("<div />", {});

    if ($("#turn-reader").turn("addPage", pageElement, pageNr)) {
      // add the initial HTML
      pageElement.html('<div class="page-loader"></div>');

      // load the page
      this._loadPage(pageNr, pageElement);
    }
  }

  _loadPage(pageNr, pageElement) {
    const currentPage = this._pubStore.findPageByPageNumber(pageNr);

    if (currentPage) {
      const publicationPageId = currentPage.PublicationPageID;
      this._appState.cdnAssetsDownloader
        .loadPreview(this._options.sizes.previews.HD, publicationPageId)
        .then((image) => {
          image.mousedown((e) => {
            e.preventDefault();
          });
          image.css({ width: "100%", height: "auto" });
          image.appendTo(pageElement);

          // remove the loader indicator
          pageElement.find(".page-loader").remove();
          const {
            reader: {
              readerSlide: { readerPage },
            },
          } = this._options;
          const clickZonesComponent = new ClickZonesComponent(
            this._appState,
            currentPage,
            Math.floor(pageNr / 2),
            readerPage,
            pageElement,
            true
          );
          clickZonesComponent.render();
        })
        .catch(() => {
          // TODO
        });
    }

    const pdf = $('<div class="page-pdf" />', {});
    pageElement.append(pdf);
  }

  _countRelativeDimentions() {
    if (!this.inFullScreenMode) {
      this.SIDEBAR_AND_MARGIN = $("#sidebar").outerWidth(true);
      // topbar + bottom nav slider + 10px space between reader and topbar
      this.TOPBAR_AND_SLIDER =
        $(".top-bar-container")[0].offsetHeight +
        10 +
        $(".reader-navigation").outerHeight(true);
    } else {
      this.SIDEBAR_AND_MARGIN = 0;
      // topbar + bottom nav slider + 10px space between reader and topbar
      this.TOPBAR_AND_SLIDER = 10 + $(".reader-navigation").outerHeight(true);
    }
    let relWidth = (document.body.clientWidth - this.SIDEBAR_AND_MARGIN) / 2;
    let relHeight = relWidth * this._appState.pageRatio;

    if (this._appState.isDoublePage) {
      if (document.body.clientHeight < relHeight + this.TOPBAR_AND_SLIDER) {
        relHeight = document.body.clientHeight - this.TOPBAR_AND_SLIDER;
        relWidth = relHeight / this._appState.pageRatio;
      }
    } else {
      const originalHeight =
        this._appState.replicaPageSize.width * this._appState.pageRatio;
      //1/3 of the image must be visible on the window
      const totalH = document.body.clientHeight - this.TOPBAR_AND_SLIDER;
      const totalW = document.body.clientWidth - this.SIDEBAR_AND_MARGIN;
      const isOneThird = originalHeight / totalH;
      if (isOneThird < this._options.singlePageDisplayedProportion) {
        relHeight = totalH * this._options.singlePageDisplayedProportion;
        relWidth = relHeight / this._appState.pageRatio;

        if (relWidth > totalW - 100) {
          relWidth = totalW - 100;
          relHeight = relWidth * this._appState.pageRatio;
        }
      } else {
        relHeight = totalH * this._options.singlePageDisplayedProportion;
        const potentialWidth = relHeight / this._appState.pageRatio;
        if (potentialWidth < totalW - 100) {
          relWidth = potentialWidth;
        } else {
          relWidth = totalW - 100;
          relHeight = relWidth * this._appState.pageRatio;
        }
      }
      //return { width: relWidth , height: relHeight  * this.zoomScale }
    }
    return { width: relWidth, height: relHeight };
  }

  _resizeBook(callback = () => {}) {
    const view = $("#turn-reader").turn("view");
    $("#turn-reader").width(0);
    $("#turn-reader").height(0);
    if (this._appState.isDoublePage) {
      $("#turn-reader").turn(
        "size",
        this._dimensions.width * 2 * this.zoomScale,
        this._dimensions.height * this.zoomScale
      );
    } else {
      $("#turn-reader").turn(
        "size",
        this._dimensions.width * this.zoomScale,
        this._dimensions.height * this.zoomScale
      );
    }

    if (this.zoomScale > 1) {
      this._prefetchPDF(view);
    }

    // needed to fix double pdf rendering if it renders to fast
    this.resizeBookNumber++;
    this._stopPdf(view);
    this.resizeBookNumber--;
    if (this.resizeBookNumber === 0) {
      this._startPdf(view);
    }
    callback();
  }

  _onWidowResize = () => {
    this._setReaderDimensions();
    this._resizeBook();
    setTimeout(() => {
      this.trigger("reader:resized");
    }, 500);
  };

  _toggleNavigationButtons(page) {
    if (page === 1) {
      this.previousLink.classList.add("hidden");
      this.singlePagePreviousLink.classList.add("hidden");
      this.nextLink.classList.remove("hidden");
      this.singlePageNextLink.classList.remove("hidden");
    } else if (page === this.totalPages) {
      this.nextLink.classList.add("hidden");
      this.singlePageNextLink.classList.add("hidden");
      this.previousLink.classList.remove("hidden");
      this.singlePagePreviousLink.classList.remove("hidden");
    } else {
      this.previousLink.classList.remove("hidden");
      this.singlePagePreviousLink.classList.remove("hidden");
      this.nextLink.classList.remove("hidden");
      this.singlePageNextLink.classList.remove("hidden");
    }
  }

  _getCenter() {
    const x =
      (this._dimensions.width + this.DOMContent.scrollLeft) / this.zoomScale;
    const y =
      (this._dimensions.height / 2 + this.DOMContent.scrollTop) /
      this.zoomScale;
    return {
      x,
      y,
    };
  }

  _getPoint(mouse) {
    const x =
      (mouse.x -
        $(this.DOMContainer).offset().left +
        this.DOMContent.scrollLeft) /
      this.zoomScale;
    const y =
      (mouse.y -
        $(this.DOMContainer).offset().top +
        this.DOMContent.scrollTop) /
      this.zoomScale;
    return {
      x,
      y,
    };
  }

  _setPoint(point, mouse) {
    this.DOMContent.scrollLeft =
      point.x * this.zoomScale - mouse.x + $(this.DOMContainer).offset().left;
    this.DOMContent.scrollTop =
      point.y * this.zoomScale - mouse.y + $(this.DOMContainer).offset().top;
  }

  _setCenter(center) {
    let xModifier = 0;
    const [leftPageNr, rightPageNr] = $("#turn-reader").turn("view");
    if (rightPageNr && leftPageNr === 0 && this.zoomScale < 2.5) {
      xModifier =
        document.querySelector(`.page.p${rightPageNr}`).clientWidth / 2;
    } else if (leftPageNr && rightPageNr === 0 && this.zoomScale < 2.5) {
      xModifier =
        -1 * (document.querySelector(`.page.p${leftPageNr}`).clientWidth / 2);
    }

    this.DOMContent.scrollLeft =
      (center.x + xModifier) * this.zoomScale - this._dimensions.width;
    this.DOMContent.scrollTop =
      center.y * this.zoomScale - this._dimensions.height / 2;
  }

  _setActivePagesInState([leftPageNr, rightPageNr], percentageInView = {}) {
    const leftPage = this._pubStore.CPackagePages[leftPageNr - 1];
    const rightPage = this._pubStore.CPackagePages[rightPageNr - 1];

    this._appState.setActivePages([leftPage, rightPage], percentageInView);
    this._appState.triggerEvent(PERCENTAGE_IN_VIEW_COMPUTED);
  }

  _recalculatePercentageInView() {
    let [leftPageNr, rightPageNr] = $("#turn-reader").turn("view");
    if (this.zoomScale === 1 && (leftPageNr === 0 || rightPageNr === 0)) {
      let percentageInView = {};
      let page;
      //
      if (leftPageNr === 0) {
        page = this._pubStore.CPackagePages[rightPageNr - 1];
      }

      if (rightPageNr === 0) {
        page = this._pubStore.CPackagePages[leftPageNr - 1];
      }
      percentageInView = getPercentInViewForSinglePage(page);
      this._setActivePagesInState(
        $("#turn-reader").turn("view"),
        percentageInView
      );
    } else {
      const pagesData = this._calculatePagesPercentageInView();
      const articlesData = this._calculateArticlesPercentageInView();

      this._setActivePagesInState($("#turn-reader").turn("view"), {
        ...pagesData,
        ...articlesData,
      });
    }
  }

  _mouseIsHoveringWhiteSpace(e) {
    const [leftPageNr, rightPageNr] = $("#turn-reader").turn("view");

    if (
      leftPageNr === 0 &&
      $(`[page=${rightPageNr}]`).offset() &&
      e.pageX < $(`[page=${rightPageNr}]`).offset().left
    ) {
      return true;
    } else if (
      rightPageNr === 0 &&
      e.pageX > $(`[page=${leftPageNr}]`).width()
    ) {
      return true;
    }

    return false;
  }

  _setCurrentReaderContainerDimentions() {
    //const readerContainerEl = document.querySelector('.reader-container');
    const readerContainerEl = document.querySelector("#reader");
    this.readerContainerDimentions = {
      left: 0,
      top: 0,
      right: readerContainerEl.clientWidth,
      bottom: readerContainerEl.clientHeight,
      surfaceArea:
        readerContainerEl.clientWidth * readerContainerEl.clientHeight,
    };
  }

  _calculateArticlesPercentageInView() {
    this._setCurrentReaderContainerDimentions();

    const [pageLeftNr, pageRightNr] = $("#turn-reader").turn("view");
    const $rightPageEl = $(`[page="${pageRightNr}"]`);
    const rightPageModifier = $rightPageEl.length
      ? $rightPageEl.position().left
      : 0;

    return {
      ...this._calculateArticlePercentageInView(pageLeftNr),
      ...this._calculateArticlePercentageInView(pageRightNr, rightPageModifier),
    };
  }

  _calculateArticlePercentageInView(pageNr, xModifier = 0) {
    const articlesData = {};

    document
      .querySelectorAll(`[page="${pageNr}"] .swiper-slide-page-click`)
      .forEach((el) => {
        let readerBookLeft = $("#turn-reader").position().left;
        let readerBookTop = $("#turn-reader").position().top;
        if (!this._appState.isDoublePage) {
          readerBookLeft -= document.querySelector("#reader").scrollLeft;
          readerBookTop -= document.querySelector("#reader").scrollTop;
        }

        const left = el.offsetLeft + readerBookLeft + xModifier;
        const top = el.offsetTop + readerBookTop;
        const right = left + el.clientWidth;
        const bottom = top + el.clientHeight;
        const articleCoordinates = {
          left: left,
          top: top,
          right: right,
          bottom: bottom,
        };

        articlesData[`article_${el.dataset.contentid}`] =
          countPercentOfContainerInZoom(
            this.readerContainerDimentions,
            articleCoordinates,
            this._options.activePageArea
          );
      });
    const normalizedArticlesData = this._appState.isDoublePage
      ? articlesData
      : this._normalizeArticlePercentageInView(articlesData);
    return normalizedArticlesData;
  }

  // This function ensures that the percentage in view is never higher than 100 in single page mode.
  _normalizeArticlePercentageInView(articlesData) {
    let sumOfPercentageInView = 0;
    let totalPercentage = this._appState.isDoublePage ? 50 : 100;

    for (const key of Object.keys(articlesData)) {
      sumOfPercentageInView += articlesData[key];
    }

    if (sumOfPercentageInView > totalPercentage) {
      for (const key of Object.keys(articlesData)) {
        articlesData[key] = Math.min(
          totalPercentage,
          (articlesData[key] / sumOfPercentageInView) * 100
        );
      }
    }

    return articlesData;
  }

  _calculatePagesPercentageInView() {
    this._setCurrentReaderContainerDimentions();
    const [pageLeftNr, pageRightNr] = $("#turn-reader").turn("view");
    const leftPage = this._pubStore.CPackagePages[pageLeftNr - 1];
    const rightPage = this._pubStore.CPackagePages[pageRightNr - 1];

    const pageEl = document.querySelector(
      `#turn-reader [page="${pageLeftNr || pageRightNr}"]`
    );

    let readerBookLeft = $("#turn-reader").position().left;
    let readerBookTop = $("#turn-reader").position().top;
    if (!this._appState.isDoublePage) {
      readerBookLeft -= document.querySelector("#reader").scrollLeft;
      readerBookTop -= document.querySelector("#reader").scrollTop;
    }

    const pagePositionLeft = pageEl.offsetLeft;
    const pagePositionTop = pageEl.offsetTop;

    const left = pagePositionLeft + readerBookLeft;
    const top = pagePositionTop + readerBookTop;
    const right = left + pageEl.clientWidth;
    const bottom = top + pageEl.clientHeight;

    const pageCoordinates = {
      left: left,
      top: top,
      right: right,
      bottom: bottom,
    };

    const percentOfSinglePageInView = countPercentOfContainerInZoom(
      this.readerContainerDimentions,
      pageCoordinates
    );

    if (pageLeftNr && pageRightNr) {
      return {
        [`page_${leftPage.PublicationPageID}`]: percentOfSinglePageInView,
        [`page_${rightPage.PublicationPageID}`]: Math.max(
          0,
          100 - percentOfSinglePageInView
        ),
      };
    }
    if (pageLeftNr) {
      return {
        [`page_${leftPage.PublicationPageID}`]: 100,
      };
    }
    if (pageRightNr) {
      return {
        [`page_${rightPage.PublicationPageID}`]: 100,
      };
    }
  }

  onPageScroll = throttle(() => {
    /* we wait 3 sec after the scroll to send the pageview event.
      the previous timer is cleared out if the user scrolls again before the 3sec
    */
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this._recalculatePercentageInView();
    }, 500);
  });
}



// WEBPACK FOOTER //
// ./src/web/reader/components/replicaReaderComponent.js